/**
 * @fileoverview GET handler for the "/alloys/partners/shopify/:app_group_id/bridges" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryFetcherAdapter } from "../reactQueryFetcherAdapters";
import { alloysPartnersShopifyAppGroupIdBridges } from "./constants";
import type { AlloysPartnersShopifyAppGroupIdBridgesResult } from "./types";
import { isAlloysPartnersShopifyAppGroupIdBridgesResult } from "./validators";

export const getAlloysPartnersShopifyAppGroupIdBridges = reactQueryFetcherAdapter(
  alloysPartnersShopifyAppGroupIdBridges,
  (signal: AbortSignal, appGroupId: string): Promise<AlloysPartnersShopifyAppGroupIdBridgesResult> => {
    return fetch(`/alloys/partners/shopify/${appGroupId}/bridges`, "GET", {}, { signal });
  },
  isAlloysPartnersShopifyAppGroupIdBridgesResult
);
